import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { TEXT_MUTED } from "./palette";

const EmptyNote = styled.div`
  color: ${TEXT_MUTED};
`;

// 各幣別金額不能直接加總，所以每個分析圖表都以幣別分面（facet）。
// 這個元件統一處理「依幣別分組 + 尚未載入 + 無資料」的骨架，圖表本身由 render prop 提供。
export default function CurrencyFacets({ rows, children }) {
  const byCurrency = useMemo(() => {
    if (!rows) return [];

    const groups = {};
    rows.forEach((row) => {
      const { id } = row.currency;
      if (!groups[id]) {
        groups[id] = { currency: row.currency, rows: [] };
      }
      groups[id].rows.push(row);
    });

    return Object.values(groups);
  }, [rows]);

  if (!rows) {
    return null;
  }

  if (byCurrency.length === 0) {
    return <EmptyNote>目前沒有花費資料可供分析。</EmptyNote>;
  }

  return byCurrency.map(({ currency, rows: currencyRows }) => children(currency, currencyRows));
}

CurrencyFacets.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.func.isRequired,
};

CurrencyFacets.defaultProps = {
  rows: null,
};
